var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLip = function SvgLip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 14a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 .75.75v11.75h-9.5V14Zm1.5.75v9.5h6.5v-9.5h-6.5ZM14.25 18a4.75 4.75 0 1 1 9.5 0v7.75h-9.5V18ZM19 14.75A3.25 3.25 0 0 0 15.75 18v6.25h6.5V18A3.25 3.25 0 0 0 19 14.75Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75v-2Zm1.5.75v.5h4.5v-.5h-4.5Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 3.571c0-.73-.592-1.321-1.321-1.321A4.179 4.179 0 0 0 6.25 6.429v6.321h5.5V3.571Zm-1.5.185v7.494h-2.5V6.429c0-1.42 1.104-2.581 2.5-2.673Z",
    fill: "#191919"
  })));
};

export default SvgLip;